import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const UserSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 17}
    height={props.width ? props.width : 17}
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      fill="#A1A1A1"
      fillRule="evenodd"
      d="M3.16 4.22A3.25 3.25 0 0 1 6.41.97h.5a3.25 3.25 0 0 1 3.25 3.25v.5a3.25 3.25 0 0 1-3.25 3.25h-.5a3.25 3.25 0 0 1-3.25-3.25v-.5Zm3.25-1.75a1.75 1.75 0 0 0-1.75 1.75v.5c0 .967.784 1.75 1.75 1.75h.5a1.75 1.75 0 0 0 1.75-1.75v-.5a1.75 1.75 0 0 0-1.75-1.75h-.5Zm-4.25 13v-1.328a4.844 4.844 0 0 1 4.33-2.671h.34a4.844 4.844 0 0 1 4.33 2.67v1.33h-9Zm4.33-5.5a6.344 6.344 0 0 0-5.761 3.686l-.069.15v3.165h12v-3.165l-.069-.15a6.344 6.344 0 0 0-5.76-3.685h-.342Zm10.101 3.686a6.34 6.34 0 0 0-2.587-2.835l-.75 1.3a4.84 4.84 0 0 1 1.906 2.02v1.33h-1v1.5h2.5v-3.165l-.069-.15ZM11.91.971h-.75v1.5h.75c.966 0 1.75.783 1.75 1.75v.5a1.75 1.75 0 0 1-1.75 1.75h-.75v1.5h.75a3.25 3.25 0 0 0 3.25-3.25v-.5A3.25 3.25 0 0 0 11.91.97Z"
      clipRule="evenodd"
    />
  </svg>
)
export default UserSVG
